import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useUserData } from "../context/UserDataContext";

import LogoutButton from "../components/auth/LogoutButton";
import CustomerPortalButton from "../components/subscription/CustomerPortalButton";
import BrandBanner from "../components/layout/BrandBanner";
import PaywallModal from "../components/modals/PaywallModal"; 
import DeleteAccountButton from "../components/auth/DeleteAccountButton";


import StreakWidget from "../components/dashboard/StreakWidget";
import FlashcardProgress from "../components/dashboard/FlashcardProgress";
import StoryProgress from "../components/dashboard/StoryProgress";

import { Capacitor } from "@capacitor/core";
import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { setAnalyticsConsent } from "../data/accountRepo";
import AnalyticsConsentSheet from "../components/modals/AnalyticsConsentSheet"; // adjust path

import { FirebaseCrashlytics } from "@capacitor-firebase/crashlytics";

import { FaCrown } from "react-icons/fa";

import "./ProfilePage.css";

export default function ProfilePage() {
  const { user } = useAuth();
  const { userData } = useUserData();
  const [showPaywall, setShowPaywall] = useState(false);

  const [showAnalyticsSheet, setShowAnalyticsSheet] = useState(false);

  const acceptAnalytics = async () => {
    if (!user?.uid) return;
    await setAnalyticsConsent({ uid: user.uid, enabled: true });
    if (Capacitor.isNativePlatform()) {
      await FirebaseAnalytics.setCollectionEnabled({ enabled: true });
    }
    setShowAnalyticsSheet(false);
  };
  
  const declineAnalytics = async () => {
    if (!user?.uid) return;
    await setAnalyticsConsent({ uid: user.uid, enabled: false });
    if (Capacitor.isNativePlatform()) {
      await FirebaseAnalytics.setCollectionEnabled({ enabled: false });
    }
    setShowAnalyticsSheet(false);
  };
  

  const displayName = userData?.name || "Usuário";
  const email = user?.email || "Email não encontrado";

  const isPaidUser =
    userData?.hasAccess && userData?.subscriptionStatus === "active";

    return (
      <>
        <BrandBanner />
    
        <div className="profile-page">
          <h1 className="profile-title">Perfil</h1>
    
          {/* USER HEADER */}
          <div className="profile-user-card">
            <div className="profile-user-info">
              <h2 className="profile-user-name">{displayName}</h2>
              <p className="profile-user-email">{email}</p>
            </div>
    
            <span className={`profile-plan-badge ${isPaidUser ? "premium" : "free"}`}>
              {isPaidUser ? "Premium" : "Plano Free"}
            </span>
          </div>
    
          {/* LANGUAGE SETTINGS */}
          <div className="profile-card profile-language-card">
            <h3 className="profile-section-title">Configurações de Idioma</h3>
    
            {/* App Language */}
            <div className="profile-language-row">
              <div className="profile-language-label">Idioma do App</div>
              <div className="profile-language-value">🇧🇷 Português</div>
            </div>
    
            <div className="profile-language-divider"></div>
    
            {/* Learning Language */}
            <div className="profile-language-row">
              <div className="profile-language-label">Aprendendo</div>
              <div className="profile-language-value">
                <select className="profile-language-select" disabled>
                  <option>🇩🇪 Alemão</option>
                  <option>🇬🇧 Inglês</option>
                  <option>🇪🇸 Espanhol</option>
                  <option>🇫🇷 Francês</option>
                </select>
              </div>
            </div>

            <p className="profile-language-coming-soon">Mais línguas em breve ❤️🤩🚀</p>

          </div>
    
          {/* PERSONAL PROGRESS */}
          <h3 className="profile-section-title">Meu Progresso</h3>
    
            <div className="profile-progress-grid">
              <StreakWidget />
              <FlashcardProgress />
              <StoryProgress />
            </div>

          <h3 className="profile-section-title">Assinatura</h3>
    
          {!isPaidUser && (
            <button className="profile-premium-btn" onClick={() => setShowPaywall(true)}>
              <FaCrown className="btn-icon" />
              Torne-se Premium
            </button>

          )}

          <CustomerPortalButton isPaidUser={isPaidUser} />
    
          <LogoutButton />

          <DeleteAccountButton />
    
          <div className="profile-help">
            Precisa de ajuda?
            contact@aprendole.com
          </div>
          
          <p className="paywall-note-second">
            <a
              className="paywall-link"
              href="https://aprendole.com/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Termos
            </a>
            {" • "}
            <a
              className="paywall-link"
              href="https://aprendole.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacidade
            </a>
            {" • "}
            <a
              className="paywall-link"
              href="https://aprendole.com/imprint"
              target="_blank"
              rel="noopener noreferrer"
            >
              Impressum
            </a>

            {Capacitor.isNativePlatform() && (
              <>
                {" • "}
                <span
                  className="paywall-link paywall-link--click"
                  onClick={() => setShowAnalyticsSheet(true)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && setShowAnalyticsSheet(true)}
                >
                  Analytics
                </span>
              </>
            )}
          </p>

          {showPaywall && (
            <PaywallModal onClose={() => setShowPaywall(false)} />
          )}

          <AnalyticsConsentSheet
            open={showAnalyticsSheet}
            mode="settings"
            onAccept={acceptAnalytics}
            onDecline={declineAnalytics}
            onClose={() => setShowAnalyticsSheet(false)}
          />

          {/* <button
              style={{ marginTop: 16 }}
              onClick={async () => {
                await FirebaseCrashlytics.crash({ message: "Test Crash" });
              }}
            >
              🔥 Test Crash (DEV)
            </button> */}

        </div>
      </>
    );
  }    